import ModuleHeader from "../../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../../config/usePrivateLink";

export default function MarketingHeader({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const tabs = [
    {
      id: "Source List",
      title: "Source List",
      icon: "ri-list-check-2",
      activePaths: ["/marketing"],
    },
    {
      id: "Source Create",
      title: "Create Source",
      icon: "ri-edit-box-line",
      activePaths: ["/marketing/add_school"],
    },
    {
      id: "AddStudent",
      title: "Add Student",
      icon: "ri-file-add-line",
      activePaths: ["/marketing/add_student"],
    },
    {
      id: "studentList",
      title: "Student List",
      icon: "ri-eye-line",
      activePaths: ["/marketing/all-students"],
    },
    {
      id: "SourceAssign",
      title: "Source Assign",
      icon: "ri-graduation-cap-line",
      activePaths: ["/AssignLeads"],
    },
    {
      id: "Call",
      title: "Call",
      icon: "ri-phone-line",
      activePaths: ["/CounselorCall"],
    },
    {
      id: "Followups",
      title: "Follow ups",
      icon: "ri-id-card-line",
      activePaths: ["/Followup"],
    },
  ];

  const permittedTabs = tabs
    .map((tab) => {
      const accessiblePaths = tab.activePaths.filter((route) =>
        hasAccess(route),
      );

      return {
        ...tab,
        path: accessiblePaths[0] || "/",
        activePaths: tab.activePaths,
        access: accessiblePaths.length > 0,
      };
    })
    .filter((tab) => tab.access);

  return (
    <>
      <div className="mt-4">
        <ModuleHeader tabs={permittedTabs} />
        {children}
      </div>
    </>
  );
}
